var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsDateString, IsObject, IsString, IsUUID } from 'class-validator';
import { UserProfileDto } from '../../user/index.js';
import { CustomFormElementAnswerLiteDto } from './custom-form-element-answer.lite.dto.js';
import { CustomFormFullSizeDto } from './custom-form.full-size.dto.js';
export class CustomFormAnswerFullSizeDto {
    id;
    createdAt;
    updatedAt;
    updatedById;
    updatedBy;
    userId;
    user;
    customFormId;
    customFormElementAnswers;
    customForm;
    get customFormOfficeId() {
        return this.customForm ? this.customForm.officeId : null;
    }
}
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CustomFormAnswerFullSizeDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", Date)
], CustomFormAnswerFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", Date)
], CustomFormAnswerFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CustomFormAnswerFullSizeDto.prototype, "updatedById", void 0);
__decorate([
    IsUUID(),
    Expose(),
    Type(() => UserProfileDto),
    __metadata("design:type", Function)
], CustomFormAnswerFullSizeDto.prototype, "updatedBy", void 0);
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CustomFormAnswerFullSizeDto.prototype, "userId", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Expose(),
    __metadata("design:type", Function)
], CustomFormAnswerFullSizeDto.prototype, "user", void 0);
__decorate([
    Expose(),
    IsUUID(),
    IsString(),
    __metadata("design:type", String)
], CustomFormAnswerFullSizeDto.prototype, "customFormId", void 0);
__decorate([
    Expose(),
    Type(() => CustomFormElementAnswerLiteDto),
    __metadata("design:type", Array)
], CustomFormAnswerFullSizeDto.prototype, "customFormElementAnswers", void 0);
__decorate([
    Expose(),
    IsObject(),
    Type(() => CustomFormFullSizeDto),
    __metadata("design:type", CustomFormFullSizeDto)
], CustomFormAnswerFullSizeDto.prototype, "customForm", void 0);
//# sourceMappingURL=custom-form-answer.full-size.dto.js.map